var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "payment-summary fsize-13 color-grey4 px-20 pt-20 pb-0" },
    [
      _vm.order.Subtotal != _vm.order.Total
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Sous Total")]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.ShopService.prix(_vm.order.Subtotal))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.ProcessingFee
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Frais de gestion")]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.ShopService.prix(_vm.order.ProcessingFee))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.order.ShippingFee
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Frais de livraison")]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.ShopService.prix(_vm.order.ShippingFee))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.Tip
        ? _c("li", { staticClass: "flex-between-end" }, [
            _c("div", [_vm._v("Pourboire")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.ShopService.prix(_vm.order.Tip)))]),
          ])
        : _vm._e(),
      _vm._v(" "),
      +_vm.order.Discount
        ? _c("li", { staticClass: "flex-between-end color-bo-p2" }, [
            !_vm.order.promo_code ? _c("div", [_vm._v("Remise")]) : _vm._e(),
            _vm._v(" "),
            _vm.order.promo_code
              ? _c("div", [_vm._v(_vm._s(_vm.order.DiscountName))])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.ShopService.prix(_vm.order.Discount))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.order.paymentRequest.fidelitePayments.length
        ? _c("li", [
            _c(
              "div",
              _vm._l(
                _vm.order.paymentRequest.fidelitePayments,
                function (fidPayment, i) {
                  return _c("div", { key: i }, [
                    _c("div", { staticClass: "flex-between-end color-bo-s2" }, [
                      _c("div", [
                        _vm._v(
                          "Carte de fidélité nº" + _vm._s(fidPayment.cardno)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.ShopService.prix(-fidPayment.Amount))
                        ),
                      ]),
                    ]),
                  ])
                }
              ),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.order.paymentRequest.comoPayments.length
        ? _c("li", [
            _c(
              "div",
              _vm._l(
                _vm.order.paymentRequest.comoPayments,
                function (comoPayment, i) {
                  return _c("div", { key: i }, [
                    _c("div", { staticClass: "flex-between-end color-bo-s2" }, [
                      _c("div", [_vm._v("Fidélité Como")]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.ShopService.prix(-comoPayment.Amount))
                        ),
                      ]),
                    ]),
                  ])
                }
              ),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "flex-between-end fsize-16 text-bold color-grey1 mt-10",
        },
        [
          _c("div", [_vm._v("Total")]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.ShopService.prix(
                  "" + _vm.PaymentService.getRemainFromFideliteCards(_vm.order)
                )
              )
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }